// import http from '@/http/index'
export default function saveSystemLog(type, text) {
  // console.log('Enter saveSystemLog: ', type, text)
  const systemLog = sessionStorage.getItem("systemLog");
  if (systemLog) {
    const logData = JSON.parse(systemLog);
    logData.data.push({
      type: type,
      createdAt: new Date(),
      data: text
    });
    sessionStorage.setItem("systemLog", JSON.stringify(logData));
  } else {
    const logJson = {
      data: [{
        type: type,
        createdAt: new Date(),
        data: text
      }]
    };
    const jsonStr = JSON.stringify(logJson);
    sessionStorage.setItem("systemLog", jsonStr);
  }

  // const sysData = {
  //   logLevel: type.toUpperCase(),
  //   eventTime: new Date(),
  //   content: text,
  // }
  // http.sendSysntemLog(sysData)
}


// WEBPACK FOOTER //
// ./src/common/saveLog.js